import React from "react";
import {Switch, Route} from "react-router-dom";
import SettingsCompanyData from "./my-company/SettingsCompanyData";
import UsersPermissions from "./my-company/UsersPermissions";
import GeneralValues from "./my-company/GeneralValues";
import UserProfile from "./my-company/UserProfile";
import WelcomePage from "./welcome-page/WelcomePage";
import VehicleTypeManagement from "./settings/VehicleTypeManagement.";
import CreateRoutesSchedules from "./settings/CreateRoutesSchedules";
import RestrictZones from "./settings/RestrictZones";
import Cancellations from "./settings/Cancellations";
import DriversManagement from "./drivers-managament/DriversManagement";
import OrderByType from "./drivers-managament/OrderByType";
import PassengersManagements from "./pasengers-managements/PassengersManagements";
import Express from "./pasengers-managements/express/Express";
import ExpressPaymentValidation from "./pasengers-managements/express/ExpressPaymentValidation";
import BookingHistory from "./reports/BookingHistory";
import TravelStatus from "./reports/TravelStatus";
import CollectionsPayments from "./reports/CollectionsPayments";
import DriverRoutes from "./reports/DriverRoutes";
import Dashboard from "./dashboard/Dashboard";
import Users from "./my-company/Users";
import Notifications from "./notifications/Notifications";
import Promotions from "./promotions/Promotions";
import {Rating} from "@material-ui/lab";
import Ratings from "./ratings/Ratings";
import BookingManagement from "./booking-management/BookingManagement";


function MainControlRoutes() {
    return (
        <Switch>
            <React.Fragment>
                <Route path={"/control-panel/welcome"} component={WelcomePage}/>
                <Route path={"/control-panel/my-company"} component={SettingsCompanyData}/>
                {/* <Route path={"/control-panel/create-users"} component={CreateUsers}/>*/}
                <Route path={"/control-panel/users"} component={Users}/>
                <Route path={"/control-panel/users-permissions"} component={UsersPermissions}/>
                <Route path={"/control-panel/general-values"} component={GeneralValues}/>
                <Route path={"/control-panel/user-profile"} component={UserProfile}/>
                <Route path={"/control-panel/vehicle-type-management"} component={VehicleTypeManagement}/>
                <Route path={"/control-panel/create-routes-schedules"} component={CreateRoutesSchedules}/>
                <Route path={"/control-panel/restrict-zones"} component={RestrictZones}/>
                <Route path={"/control-panel/cancellations"} component={Cancellations}/>
                <Route path={"/control-panel/drivers-management"} component={DriversManagement}/>
                <Route path={"/control-panel/order-by-type"} component={OrderByType}/>
                <Route path={"/control-panel/passengers-managements"} component={PassengersManagements}/>
                <Route path={"/control-panel/express"} component={Express}/>
                <Route path={"/control-panel/express-payment-validation"} component={ExpressPaymentValidation}/>
                <Route path={"/control-panel/booking-history"} component={BookingHistory}/>
                <Route path={"/control-panel/travel-status"} component={TravelStatus}/>
                <Route path={"/control-panel/collections-payments"} component={CollectionsPayments}/>
                <Route path={"/control-panel/driver-routes"} component={DriverRoutes}/>
                <Route path={"/control-panel/dashboard"} component={Dashboard}/>
                <Route path={"/control-panel/notifications"} component={Notifications}/>
                <Route path={"/control-panel/promotions"} component={Promotions}/>
                <Route path={"/control-panel/Ratings"} component={Ratings}/>
                <Route path={"/control-panel/booking-management"} component={BookingManagement}/>
            </React.Fragment>
        </Switch>
    )
}

export default MainControlRoutes



